import React, { useEffect, useState } from 'react';
import { Form, Input, Col, Row, InputNumber } from 'antd';
import { FormInstance } from 'antd/lib/form';
import FormInput from 'components/FormInput';
import Address from 'components/address';
import ButtonLink from 'components/theme_components/ButtonLink';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import ParListSelect from 'components/ParListSelect';
import TaxSelect from 'components/TaxSelect';

export type GeneralDataProps = {
  form: FormInstance;
  required: boolean;
  onEdit?: () => void;
  onSave?: (update: any) => void;
  tptype?: string
};

const GeneralData = ({ form, required }: GeneralDataProps) => {
  const [paymentDelegation, setPaymentDelegation] = useState<boolean | null>(null);
  function isNumeric(value: string) {
    return /^[0-9]+$/.test(value);
  }
  useEffect(() => {
    const tppaymentdelegation = form.getFieldValue('tppaymentdelegation');
    // Ensure to convert the value to a boolean
    if (tppaymentdelegation === 'TRUE') {
      setPaymentDelegation(true);
    } else if (tppaymentdelegation === 'FALSE') {
      setPaymentDelegation(false);
    }
  }, [form]);
  const tpCountry = form.getFieldValue("tpmainadrcountry")?.toUpperCase() || "";
  const validateTptaxid = (_: any, value: string) => {
    if (!value) {
      return Promise.reject("")
    }


    const regex = /^[A-Za-z]{2}\d{11}$/
    if (!regex.test(value)) {
      return Promise.reject("Le code doit être composé de 2 lettres suivies de 11 chiffres.")
    }
    // this code to be reviewzed when we add more countries...
    // const countryCode = value.slice(0, 2).toUpperCase()
    // if (countryCode && countryCode !== tpCountry) {
    //   return Promise.reject("Les 2 premières lettres doivent correspondre au code pays.")
    // }
    const countryCode = value.slice(0, 2).toUpperCase()
    if (countryCode !== "FR") {
      return Promise.reject("Les 2 premières lettres doivent correspondre au code pays.(FR)")
    }
    const fiscalId = form.getFieldValue("tpfiscalid")
    if (fiscalId && fiscalId.length >= 9) {
      const expectedSuffix = fiscalId.slice(0, 9)
      if (value.slice(4, 13) !== expectedSuffix) {
        return Promise.reject(
          "Les 9 derniers chiffres doivent être égaux au SIREN (9 premiers chiffres de l'identifiant juridique)",
        )
      }
    }

    return Promise.resolve()
  }

  return (
    <Row justify="space-between">
        <FormInput col md={9} name="tpreference" rules={[{ required: required }]} >
          <Input disabled />
        </FormInput>

        <FormInput col md={14} name="tpname" comcode="tpnameTP" rules={[{ required: required }]}>
          <Input />
        </FormInput>

        <FormInput col md={9} name="tpfiscalid" rules={[
          { required: true },
          () => ({
            validator(_, value: string) {
              if (value.length > 0 && value.length != 14 || !isNumeric(value)) {
                return Promise.reject(`L'identifiant juridique doit être composé uniquement de chiffres et comporter exactement 14 chiffres.`);
              }

              return Promise.resolve();
            },
          }),
        ]} comcode='tpfiscalidTP'>
          <Input />
        </FormInput>
        <FormInput col md={14} name="tplegalform" comcode='tplegalformTP' rules={[{ required: required }]}>
          <ParListSelect parcode='LEGALFORM' />
        </FormInput>
        <FormInput col md={9} name="tptaxid" comcode='tptaxidTP' rules={[{ required: required }, { validator: validateTptaxid }]}>
          <Input />
        </FormInput>
        <FormInput col md={14} name="taxregime" comcode='taxregime' rules={[{ required: required }]}>
          <ParListSelect parcode='REGIMETVA' />
        </FormInput>




      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) => prevValues.tpcategory !== currentValues.tpcategory}
      >
        {({ getFieldValue }) => {
          const isB2B = getFieldValue("tpcategory") === "B2B"
          const isTrader = getFieldValue("tpcategory") === "TRADER"
          return (
            <>
              <FormInput md={isTrader ? 22 : 14} rules={[{ required: required }]} col name="tpcategory">
                <ParListSelect parcode="TPCATEGORY" />
              </FormInput>

              {isB2B && <FormInput col md={9} rules={[{ required: required }]} name="tppaymentdelegation">
                <ParListSelect parcode="TPPAYDELEG" />
              </FormInput>}

              {!isB2B && !isTrader && (
                <FormInput col md={9} name="tpbrand" comcode="tpbrandTP" rules={[{ required: required }]}>
                  <ParListSelect parcode="TPBRAND" />
                </FormInput>
              )}
            </>
          )
        }}
      </Form.Item>
    </Row >
  );
};

export default GeneralData;
